enum AppStoreActions {}

enum AppStoreMutations {
  SET_LOADING = "setLoading",
}

export { AppStoreMutations, AppStoreActions };
